import React from 'react';
import { Helmet } from 'react-helmet';
import ReactTyped from 'react-typed';
import sImage1 from '../container/image/s1.jpg'
import sImage2 from '../container/image/s2.jpg'

const About = () => {
    return ( 
        <div className="container bg-white py-5 mt-sm-2">
            <Helmet>
                <title>3 دان | درباره ما ، متخصصین ، مکان ، خیریه ، سندروم دان ،</title>
            </Helmet>
            <header>
                <h5 className="font-weight-bold text-dark text-center mb-5 rtl">
                    <ReactTyped
                        strings={["با ما همراه شوید در موفقیت و سعادت !", "با ما همراه شوید در کار نیک !"]}
                        typeSpeed={80}
                        backSpeed={80}
                        backDelay={2000}
                        loop
                        smartBackspace
                    />
                </h5>
            </header>
            <div className="px-lg-5">
                <p>
                    مجموعه ی « سه دان » با بهره مندی از نیروهای متخصص ، سعی به رفع نیاز به کالاهای 
                    اساسی مردم عزیزمان کرده است . این نیاز ها را در قالب تأمین نیروهای متخصص 
                    تأسیساتی و تعمیراتی لوازم منزل و همچنین معرفی مکان های معتبر موجود فروشگاهی و ... 
                    به عمل آورده است .
                </p>
                <p>
                    بخشی از در آمد حاصل از این طرح به بیماران سندروم دان هدیه خواهد شد . چنانچه در این خدمت 
                    قصد مشارکت دارید ، این بیماران را با کمک های پر مهر و محبت خود ، خوشحال کنید.
                </p>
                <div className="d-flex justify-content-center">
                    <div>
                        <img src={sImage1} alt="" className="img-fluid"/>
                    </div>
                    <div>
                        <img src={sImage2} alt="" className="img-fluid"/>
                    </div>
                </div>
                <h5 className="text-dark font-weight-bold mt-4">
                    <i 
                        className="fa fa-handshake-o" 
                        style={{position:'relative', top:'3px', left:'5px'}}
                    ></i>
                    همکاری با ما
                </h5>
                <p>
                    چنانچه بعنوان نیروی تأسیساتی و تعمیراتی تمایل به همکاری با ما را
                    دارید و یا میخواهید فروشگاه و مغازه خود را در بخش
                    مکان های معتبر سایت ما ثبت کنید ، با شماره 09153218055 تماس بگیرید.
                </p>
            </div>
        </div>
     );
}
 
export default About;